import qs from 'qs';

const EmailTemplate = {
    namespaced: true,

    state: {
        emailTemplateData: [],
        sendPulseEmailTemplateData: [],
    },

    getters: {
        emailTemplateData (state) {
            return state.emailTemplateData;
        },
        sendPulseEmailTemplateData (state) {
            return state.sendPulseEmailTemplateData;
        },
    },

    mutations: {

        /**
         * Установить значение объекта
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['emailTemplateData'] = items;
        },

        /**
         * Установить значение объекта (SendPulse)
         * @param state
         * @param items
         */
         setArrSendPulse (state, { items }) {
            state['sendPulseEmailTemplateData'] = items;
        },

        /**
         * Обновить значение элемента объекта
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['emailTemplateData'][index] = item;
        },

        /**
         * Добавить значение элемента объекта
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['emailTemplateData'].push(item);
        },

        /**
         * Удалить элемент из объекта
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['emailTemplateData'] = state['emailTemplateData'].filter(iItem => iItem !== item);
        },
    },


    actions: {

        /**
         * Получение данных по шаблонам
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getEmailTemplateData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl + 'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.emailTemplate,
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),  
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по шаблонам писем получены.'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true}),
                    console.log('ERROR IN emailTemplate.js | getEmailTemplateData : ' + err);
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при получении данных по шаблонам писем!'),
                    reject(err);
                });
            })
        },

        /**
         * Сохранение данных по шаблонам email 
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        saveEmailTemplateData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.data);
                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.emailTemplate
                    }),
                }).then(response => {

                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по шаблонам писем успешно отредактированы!');

                    // Если сохранение нового
                    } else {
                        data.data.id = response.data[0].id;
                        commit('addItem', {
                            item: data.data
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новый шаблон письма успешно создан!');
                    }
                    resolve();
                }).catch(err => {
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении шаблона письма!');
                        console.log('ERROR IN emailTemplate.js | saveEmailTemplateData : ' + err);
                        reject(err);
                });
            })
        },

        /**
         * Удаление шаблона
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removeEmailTemplateData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.item);
                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.emailTemplate,
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Шаблон письма успешно удален!'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении шаблона письма!'),
                    console.log('ERROR IN emailTemplate.js | removeEmailTemplateData : ' + err);
                    reject(err);
                });
            })
        },

        /**
         * Получение данных по шаблонам SendPulse
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
         getSendPulseEmailTemplateData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl + 'send-pulse-mail/list-templates',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        /* 'service': rootGetters.service.emailTemplate, */
                    }),
                }).then(response => (
                    commit('setArrSendPulse', {
                        items: response.data
                    }),  
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по шаблонам SendPulse получены.'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true}),
                    console.log('ERROR IN emailTemplate.js | getSendPulseEmailTemplateData : ' + err);
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при получении данных по шаблонам SendPulse!'),
                    reject(err);
                });
            })
        },
    },
};

export default EmailTemplate;





// WEBPACK FOOTER //
// ./src/store/modules/emailTemplate.js